import { render, staticRenderFns } from "./SupplierPerformanceWorldMap.vue?vue&type=template&id=c495aa2e&scoped=true"
import script from "./SupplierPerformanceWorldMap.vue?vue&type=script&lang=js"
export * from "./SupplierPerformanceWorldMap.vue?vue&type=script&lang=js"
import style0 from "./SupplierPerformanceWorldMap.vue?vue&type=style&index=0&id=c495aa2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c495aa2e",
  null
  
)

export default component.exports